import { defineFilterSpec, enumField, text } from '@/lib/api/filter-spec';

import type { UserFilterFormValues, UserListFilters } from './types';

/** Single declaration of the Internal Users list filters (D11). `search` participates only in the
 *  query params; `role`/`status` are single-select enums that also drive the filter drawer + active dot. */
const spec = defineFilterSpec<UserListFilters, UserFilterFormValues>([
  text('search'),
  enumField('role'),
  enumField('status'),
]);

export const toListQuery = spec.toListQuery;
export const hasActiveFilters = spec.hasActiveFilters;
